export const PL_HELP_SIRI_DEV_NETWORK_TAG_ID = 1067;
export const DARI_HELPER_PROD_NETWORK_TAG_ID = 1206;
export const DARI_HELPER_PROD_SOURCE_TAG_ID = 1207;

export const loyaltyHelpTagEnabled = (
  isDev: boolean,
  networkTags?: { tag_id: number }[],
  sourceTags?: { tag_id: number }[]
) =>
  isDev
    ? !!networkTags?.some(
        (tag) => tag.tag_id === PL_HELP_SIRI_DEV_NETWORK_TAG_ID
      )
    : !!networkTags?.some(
        (tag) => tag.tag_id === DARI_HELPER_PROD_NETWORK_TAG_ID
      ) ||
      !!sourceTags?.some(
        (tag) => tag.tag_id === DARI_HELPER_PROD_SOURCE_TAG_ID
      );
